export const positionTurn = (pos) => {
  const ar = [...pos];
  ar.push(ar.shift());
  return ar;
};
